import LoginPage from "./LoginPage/LoginPage";
import ChangePasswordPage from "./LoginPage/ChangePassword";
import ForgotPasswordPage from "./ForgotPasswordPage/ForgotPasswordPage";
import ConfirmEmailPage from "./ForgotPasswordPage/ConfirmEmailPage";
import RedirectToEsign from "./RedirectToEsign";
import SsoKickoff from "./SsoKickoff";
// import DashboardOverview from './StartPage/DashboardOverview';
// import Services from './Services/Services';
import Documents from "./Documents/Documents";
import CompareDocumentIFramePage from "./Compare/IFramePage";
import Settings from "./Settings/Settings";
// import CreateTicket from './Support/CreateTicket';
import EditUserProfile from "./EditUserProfile/EditUserProfile";

const RoutesList = [
  /**
   * Export the array with all components, their corresponding paths and type.
   */
  {
    path: "/login",
    component: LoginPage,
    type: "public",
  },
  {
    path: "/changePassword",
    component: ChangePasswordPage,
    type: "public",
  },
  {
    path: "/forgotten-password",
    component: ForgotPasswordPage,
    type: "public",
  },
  {
    path: "/confirm-email/:uniqueId/:mail",
    component: ConfirmEmailPage,
    type: "public",
  },
  {
    path: "/redirect-to-veditor",
    component: RedirectToEsign,
    type: "redirect",
  },
  {
    path: "/sso",
    component: SsoKickoff,
    type: "public",
  },
  // {
  // 	path: '/start',
  // 	component: DashboardOverview,
  // 	type: 'private',
  // },
  // {
  // 	path: '/services',
  // 	component: Services,
  // 	type: 'private',
  // },
  {
    path: "/documents/:serviceID/:status",
    component: Documents,
    type: "private",
  },
  {
    path: "/compare-documents/:jobId",
    component: CompareDocumentIFramePage,
    type: "private",
  },
  {
    path: "/settings/:option",
    component: Settings,
    type: "private",
  },
  // {
  // 	path: '/support',
  // 	component: CreateTicket,
  // 	type: 'private',
  // },
  {
    path: "/edit-user-profile",
    component: EditUserProfile,
    type: "private",
  },
];

export default RoutesList;
